<template>
	<div class="page">
		<gc-header header-data="staffManage">
			<template #ops>
				<el-button type="primary" @click="handleShowStaffModal({ action: 'add' })">新增员工</el-button>
			</template>
		</gc-header>
		<div class="page-main" v-loading="loading">
			<div class="search-modal">
				<gc-custom-search
					:search.sync="searchKeywords"
					key-word-width="72px"
					key-word="员工姓名"
					placeholder="请输入检索关键字"
					@on-keyup-enter="queryStaffPageList"
				>
					<i class="el-icon-search" slot="icon" style="cursor: pointer" @click="queryStaffPageList"></i>
				</gc-custom-search>
			</div>
			<div class="staff-list" v-if="staffList.length">
				<staff-item
					v-for="item in staffList"
					:key="item.id"
					:staff-item="item"
					@modify-staff="handleShowStaffModal"
					@update-account="handleModifyAccount"
				></staff-item>
			</div>
			<gc-empty v-else></gc-empty>
		</div>

		<!-- 新增/编辑员工信息 -->
		<modify-staff
			ref="updateStaffModel"
			:departmentTree="organizationTreeOptions"
			isManufacturer
			@refresh-staff-list="queryStaffPageList"
		/>

		<!-- 编辑账号 -->
		<modify-account ref="modifyAccount" @refresh-staff-list="queryStaffPageList"></modify-account>
	</div>
</template>

<script>
import { apiGetOrganizations, apiGetStaffList } from '@/apis/organizeStaff.api'
import StaffItem from '@/pages/organize-manage/staff-manage/components/StaffItem.vue'
import ModifyStaff from '@/pages/organize-manage/staff-manage/components/ModifyStaff.vue'
import ModifyAccount from '@/pages/organize-manage/staff-manage/components/ModifyAccount.vue'
export default {
	name: 'ManStaffManage',
	components: {
		StaffItem,
		ModifyStaff,
		ModifyAccount,
	},
	data() {
		return {
			searchKeywords: '',
			staffList: [],
			loading: false,
			organizationTreeOptions: [],
		}
	},

	created() {
		this.queryOrganizeTreeOptions()
		this.queryStaffPageList()
	},

	methods: {
		async queryStaffPageList() {
			this.loading = true
			try {
				const data = await apiGetStaffList({
					isPaged: false,
					name: this.searchKeywords,
					isManufacturer: true,
				})
				this.loading = false
				this.staffList = data.dataList || []
			} catch (error) {
				this.loading = false
				this.staffList = []
			}
		},

		queryOrganizeTreeOptions() {
			if (this.orgEnable) {
				apiGetOrganizations().then(res => {
					if (!res) return (this.organizationTreeOptions = [])
					this.organizationTreeOptions = res.children
				})
			}
		},

		handleShowStaffModal({ action, data }) {
			this.$refs.updateStaffModel[action](data)
		},

		handleModifyAccount(val) {
			this.$refs.modifyAccount.edit(val)
		},
	},

	computed: {
		userInfo() {
			return this.$store.getters.userInfo
		},

		orgEnable() {
			return this.userInfo.isOrgEnable || false
		},
	},
}
</script>
<style lang="scss" scoped>
.page-main {
	display: flex;
	padding: 16px;
	flex-direction: column;
	.staff-list {
		margin-top: 30px;
		flex: 1;
		overflow-y: scroll;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	}
}
</style>
